export default __webpack_public_path__ + "static/media/linkedInImg.080ec1d4.jpeg";